import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import CreatableSelect from "react-select/creatable";
import FormErrors from "shared/react_components/FormErrors";
import selectOptions from "shared/prop_types/selectOptions";

const createOption = label => ({ label, value: label });

export default class TagListInput extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.arrayOf(PropTypes.string),
    valueDelimiters: PropTypes.arrayOf(PropTypes.string),
    options: selectOptions,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    errors: FormErrors.propTypes.errors,
    isUnique: PropTypes.func,
    allowCustomOptions: PropTypes.bool,
    isDisabled: PropTypes.bool
  };

  static defaultProps = {
    value: [],
    valueDelimiters: ["Enter", "Tab"],
    placeholder: "",
    options: [],
    onChange: () => {},
    onBlur: () => {},
    onFocus: () => {},
    isUnique: () => true,
    allowCustomOptions: true
  };

  state = { currentInputValue: "" };

  handleChange = newValue => {
    const value = (newValue || []).map(v => (typeof v === "object" ? v.value : v));
    this.props.onChange({ target: { value, name: this.props.name } });
  };

  handleInputChange = currentInputValue => this.setState({ currentInputValue });

  handleInputFocus = () => {
    const { onFocus } = this.props;
    onFocus();
    this.setState({ openMenu: true });
  };

  handleKeyDown = event => {
    const { currentInputValue } = this.state;
    const { value, valueDelimiters, isUnique } = this.props;

    if (currentInputValue && valueDelimiters.includes(event.key) && this.props.allowCustomOptions) {
      this.setState(
        { currentInputValue: "" },
        () => isUnique(currentInputValue, value) && this.handleChange([...value, currentInputValue])
      );
      event.preventDefault();
    }
  };

  handleBlurChange = event => {
    this.setState({ openMenu: false });
    const { value, onBlur } = this.props;
    const newValue = event.target.value;
    if (newValue !== "" && this.props.allowCustomOptions) {
      this.handleChange([...value, newValue]);
    }

    onBlur();
  };

  render() {
    const { currentInputValue, openMenu } = this.state;
    const { value, placeholder, name, errors, options, allowCustomOptions, isDisabled } = this.props;

    return (
      <div data-test-id="tag-list-input-wrapper">
        <CreatableSelect
          name={name}
          classNamePrefix="react-select"
          className={classNames("react-select", { "is-invalid": !!errors })}
          components={{ DropdownIndicator: null }}
          inputValue={currentInputValue}
          isClearable
          isMulti
          menuIsOpen={openMenu && options.length > 0}
          options={options}
          onChange={this.handleChange}
          onInputChange={this.handleInputChange}
          onKeyDown={this.handleKeyDown}
          placeholder={placeholder}
          value={value.map(label => createOption(label))}
          onFocus={this.handleInputFocus}
          onBlur={this.handleBlurChange}
          isValidNewOption={() => allowCustomOptions}
          isDisabled={isDisabled}
        />
        {errors && <FormErrors className="d-block" errors={errors} />}
      </div>
    );
  }
}
